<template>
  <!-- uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky" -->
  <div id="navbar" class="uk-navbar-container uk-light">
    <div class="uk-container uk-container-expand uk-margin-left uk-margin-right">
      <nav uk-navbar>
        <!-- <a class="uk-navbar-toggle uk-hidden@m" uk-navbar-toggle-icon href="#offcanvas" uk-toggle></a> -->
        <div class="uk-navbar-left" style="height: 80px;">
          <a class="uk-navbar-toggle uk-hidden@m" href="#offcanvas" uk-toggle>
            <span uk-navbar-toggle-icon></span> <span class="uk-margin-small-left">Menu</span>
          </a>
        </div>
        <div class="uk-navbar-center">
          <div class="uk-navbar-center-left uk-visible@m" style="margin-right: 40px">
            <ul class="uk-navbar-nav">
              <router-link to="/offer" tag="li" active-class="uk-active">
                <a>{{ Translations.Offer }}</a>
              </router-link>
              <!--router-link to="/customers" tag="li" active-class="uk-active">
                <a>{{ Translations.Customers }}</a>
              </router-link-->
            </ul>
          </div>
          <router-link to="/" class="brand uk-navbar-item uk-logo">
            <img src="../../assets/logo.ee.png" style="width: 60px;">
          </router-link>
          <div class="uk-navbar-center-right uk-visible@m" style="margin-left: 40px">
            <ul class="uk-navbar-nav">
              <router-link to="/company" tag="li" active-class="uk-active">
                <a>{{ Translations.Company }}</a>
              </router-link>
            </ul>
          </div>
        </div>
        <div class="uk-navbar-right">
          <ul class="uk-navbar-nav">
            <router-link to="/blog" tag="li" active-class="uk-active">
              <a>{{ Translations.Blog }}</a>
            </router-link>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      Translations: {
        Title1: 'Experience',
        Title2: 'Excellence',
        Offer: 'Aanbod',
        Customers: 'Klanten',
        Company: 'Bedrijf',
        Blog: 'Blog'
      }
    }
  }
}
</script>

<style scoped>
#navbar {
    background-color: #2a144c;
    position: sticky;
    top: 0px;
    z-index: 100;
}

a.uk-logo {
    text-transform: uppercase;
}

.brand {
    font-family: 'Patua One', serif;
    line-height: 1em;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/NavBar.vue